<template>
  <v-sheet>
    <v-radio-group
      v-if="!hideGrouping"
      v-model="groupBy"
      label="Group By:"
      row
      dense
    >
      <v-radio
        v-if="hasSemesterBasedPlans"
        label="Semester"
        value="semester.semesterId"
      ></v-radio>
      <v-radio label="Program" value="program"></v-radio>
      <v-radio label="Client" value="client.fullName"></v-radio>
    </v-radio-group>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="rows"
      :search="search"
      :group-by="groupBy"
      :group-desc="groupBy === 'semester.semesterId'"
      sort-by="approvalStartDate"
      sort-desc
    >
      <template
        v-slot:[`group.header`]="{ group, headers, toggle, isOpen, items }"
      >
        <td :colspan="headers.length">
          <v-btn @click="toggle" x-small icon :ref="group">
            <v-icon v-if="isOpen">mdi-minus</v-icon>
            <v-icon v-else>mdi-plus</v-icon>
          </v-btn>
          <span
            v-if="groupBy === 'client.fullName'"
            class="mx-5 text-decoration-underline indigo--text"
            style="cursor: pointer"
            @click="goToClient(items[0].clientId)"
            >{{ group }}</span
          >
          <span v-else class="mx-5 font-weight-bold" style="font-size: 14px">{{
            groupBy === "semester.semesterId" ? semesterLabel(items[0]) : group
          }}</span>
        </td>
      </template>
      <template v-slot:[`item.client.fullName`]="{ item }">
        <span
          style="cursor: pointer"
          class="text-decoration-underline indigo--text"
          @click="goToClient(item.clientId)"
          >{{ item.client.fullName }}</span
        ></template
      >
      <template v-slot:[`item.mandate`]="{ item }">
        <span>{{ item.mandate }}</span
        ><v-chip
          :active="Boolean(item.isSubstitute)"
          x-small
          pill
          label
          color="accent"
          class="ma-2"
        >
          Sub
        </v-chip></template
      >
    </v-data-table>
  </v-sheet>
</template>

<script>
import { deduplicate } from "../../utils/data-table-utils";
export default {
  props: [
    "assignments",
    "loading",
    "hideGrouping",
    "search",
    "hideMandateDetails",
  ],
  data() {
    return {
      groupBy: this.hideGrouping ? null : "semester.semesterId",
    };
  },
  computed: {
    // hide semester column / group-by option when all cases are calendar-based
    hasSemesterBasedPlans() {
      return this.assignments.some((item) =>
        this.$store.getters["optionsModule/getIsSemesterBasedPlanType"](
          item.planTypeId
        )
      );
    },
    headers() {
      return [
        { text: "Client", value: "client.fullName" },
        { text: "Date of Birth", value: "client.formattedDob" },
        { text: "OSIS", value: "client.formattedOsis" },
        { text: "School", value: "school.schoolName" },
        {
          text: "Semester",
          value: "semester.semesterCode",
          hide: !this.hasSemesterBasedPlans,
        },
        {
          text: "Assignment Start Date",
          value: "formattedApprovalStartDate",
          hide: this.hideMandateDetails,
        },
        {
          text: "Assignment End Date",
          value: "formattedApprovalEndDate",
          hide: this.hideMandateDetails,
        },
        { text: "Program", value: "program" },
        { text: "Service", value: "service" },
        {
          text: "Assigned Hours",
          value: "mandate",
          hide: this.hideMandateDetails,
        },
        {
          text: "Start Date",
          value: "formattedStartDate",
          hide: this.hideMandateDetails,
        },
        {
          text: "End Date",
          value: "formattedEndDate",
          hide: this.hideMandateDetails,
        },
      ].filter((header) => !header.hide);
    },
    // keyed on the visible columns, so rows that render identically collapse
    rows() {
      return deduplicate(
        this.assignments,
        this.headers.map((header) => header.value)
      );
    },
  },
  watch: {
    // the parent loads the cases, so we only know whether the semester grouping
    // applies once they arrive
    assignments() {
      if (
        !this.hasSemesterBasedPlans &&
        this.groupBy === "semester.semesterId"
      ) {
        this.groupBy = "program";
      }
    },
  },
  methods: {
    // calendar-based cases have no semester, so they all collect in one group
    semesterLabel(item) {
      return item?.semester?.semesterCode ?? "N/A";
    },
    goToClient(clientId) {
      this.$router.push({
        name: "ClientDetails",
        params: { clientId: clientId },
      });
    },
  },
};
</script>
